// cw-bf sticky bar: publishes its height for the page padding, hides while the offer box is on screen.
const bar = document.querySelector('.cw-bf-sb');
if (bar) {
  const root = document.documentElement;
  const setHeight = () => root.style.setProperty('--cw-sticky-h', `${bar.offsetHeight}px`);
  setHeight();
  window.addEventListener('resize', setHeight, { passive: true });
  const offer = document.getElementById('cw-offer');
  if (offer && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => bar.classList.toggle('is-hidden', entry.isIntersecting));
    }, { threshold: 0.15 }).observe(offer);
  }
}

// cw-bf offer form: one submit only; the cart drawer option adds in place and opens the theme drawer.
document.querySelectorAll('.cw-bf-of__form').forEach((form) => {
  const btn = form.querySelector('.cw-bf-of__btn');
  const err = form.querySelector('.cw-bf-of__err');
  form.addEventListener('submit', (event) => {
    if (btn.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    const gift = form.querySelector('input[name="cw_gift"]');
    if (gift && gift.value) {
      // gift set in the section: add the chosen pair and the gift in one call, then go where the button says
      event.preventDefault();
      const picked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const items = [{ id: Number(picked.value), quantity: 1 }, { id: Number(gift.value), quantity: 1 }];
      fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST', body: JSON.stringify({ items }), headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) throw new Error(res.description || 'add failed');
          window.location.href = btn.dataset.cwAction === 'checkout' ? '/checkout' : '/cart';
        })
        .catch(() => { if (err) err.hidden = false; btn.removeAttribute('aria-busy'); });
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (btn.dataset.cwAction !== 'drawer' || !drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const data = new FormData(form);
    data.delete('return_to');
    const sections = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((x) => x.id) : [];
    if (sections.length) { data.append('sections', sections.join(',')); data.append('sections_url', window.location.pathname); }
    fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) throw new Error(res.description || 'add failed');
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      })
      .catch(() => { if (err) err.hidden = false; })
      .finally(() => btn.removeAttribute('aria-busy'));
  });
});
// cw-bf offer picker: the main photo follows the chosen option; the option selected on load keeps the section photo.
document.querySelectorAll('.cw-bf-of').forEach((box) => {
  const photo = box.querySelector('.cw-bf-of__photo');
  const inputs = [...box.querySelectorAll('.cw-bf-of__opt input[type=radio]')];
  if (!photo || !inputs.some((i) => i.dataset.cwSrc)) return;
  const base = { src: photo.getAttribute('src'), srcset: photo.getAttribute('srcset') || '', alt: photo.alt };
  let turn = 0;
  const show = (input) => {
    const next = input.hasAttribute('data-cw-photo-default') || !input.dataset.cwSrc
      ? base : { src: input.dataset.cwSrc, srcset: input.dataset.cwSrcset || '', alt: input.dataset.cwAlt || base.alt };
    const mine = ++turn;
    if (photo.getAttribute('src') === next.src) return;
    const pre = new Image();
    pre.sizes = photo.sizes;
    pre.srcset = next.srcset;
    pre.src = next.src;
    const apply = () => {
      if (mine !== turn) return;
      photo.srcset = next.srcset;
      photo.src = next.src;
      photo.alt = next.alt;
    };
    (pre.decode ? pre.decode() : Promise.resolve()).then(apply, apply);
  };
  inputs.forEach((input) => input.addEventListener('change', () => { if (input.checked) show(input); }));
  const checked = inputs.find((i) => i.checked);
  if (checked) show(checked);
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) document.querySelectorAll('.cw-bf-of__btn[aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
});
